import { gql } from '@apollo/client';
import { query } from '../apollo/ApolloClient';

const ALARM_GROUP_QUERY = gql`
  query alarmGroup($id: Int32!) {
    alarmGroup(id: $id) {
      id
      startTime
      endTime
      alarmDetails {
        timeseries
        score
        error
      }
      isRanked
    }
  }
`;

const ALARM_GROUPS_QUERY = gql`
  query alarmGroups($first: Int32!, $dir: String!, $cursor: Int32) {
    alarmGroups(first: $first, dir: $dir, cursor: $cursor) {
      total
      groups {
        id
        startTime
        endTime
        alarmDetails {
          timeseries
        }
      }
    }
  }
`;

export interface AlarmDetails {
  timeseries: Record<string, string>;
  score?: number;
  error?: string;
}

export interface AlarmGroup {
  id: number;
  jobId?: number;
  startTime: string;
  endTime: string;
  alarmDetails: AlarmDetails[];
  isRanked?: boolean;
}

export interface AlarmGroupsResp {
  groups: AlarmGroup[];
  total: number;
}

export const getAlarmGroup = async (id: number): Promise<AlarmGroup> => {
  const data = await query<Record<string, AlarmGroup>>({
    query: ALARM_GROUP_QUERY,
    variables: {
      id,
    },
    // fetchPolicy: 'network-only',
  });

  return data!.alarmGroup;
};

export const getAlarmGroups = async (first: number, dir: string, cursor?: number): Promise<AlarmGroupsResp> => {
  const data = await query<Record<string, AlarmGroupsResp>>({
    query: ALARM_GROUPS_QUERY,
    variables: {
      first,
      dir,
      cursor: cursor || null,
    },
    // fetchPolicy: 'network-only',
  });

  return data!.alarmGroups;
};
